import Glide, {Controls, Images, Swipe} from '@glidejs/glide/dist/glide.modular.esm';

const allBlocks = document.querySelectorAll('.block-slider');

allBlocks.forEach(block => {
  const blockId = block.getAttribute('id');
  const allSlides = block.querySelectorAll('.glide__slide');
  const allArrows = block.querySelectorAll('.glide__arrow');
  let track = block.querySelector('.glide__track');

  const glide = new Glide('#' + blockId + ' .glide', {
    autoHeight: true,
  });

  glide.on(['mount.after', 'run', 'resize'], () => {
    const currentSlideElement = allSlides[glide.index];
    const currentImage = currentSlideElement.querySelector('img');

    // Set dynamic height of slides-container based on current slide.
    track.style.height = currentSlideElement.scrollHeight + 'px';

    if(!currentImage){
      return;
    }

    // Also adjust arrows top position to ignore image caption
    // We want them to be in the vertical center of the image. Not the whole container.
    allArrows.forEach(arrow => {
      arrow.style.top = (currentImage.scrollHeight / 2) + 'px';
    });
  });

  glide.mount({Swipe, Controls, Images})
});


